import styled from "styled-components";

import { colors, radii, shadows } from "shared/ui/tokens";

export const Container = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 2px;
    padding: 2px;
    background: ${colors.segmentBg};
    border-radius: ${radii.base};
    max-width: 100%;
`;

export const Pill = styled.button<{ $active: boolean }>`
    height: 40px;
    padding: 0 14px;
    border: 0;
    border-radius: ${radii.small};
    font-size: 13px;
    font-weight: 700;
    line-height: 1;
    white-space: nowrap;
    flex: none;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    background: ${({ $active }) => ($active ? colors.surface : "transparent")};
    color: ${({ $active }) => ($active ? colors.primary : colors.fieldLabel)};
    box-shadow: ${({ $active }) => ($active ? shadows.activePill : "none")};
`;

export const Dot = styled.span<{ $visible: boolean }>`
    width: 5px;
    height: 5px;
    border-radius: 50%;
    flex: none;
    background: ${({ $visible }) => ($visible ? colors.amber : "transparent")};
`;
